import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSymptomPriorities, useSymptomPrioritiesById } from '../hooks';
import { useFeatureFlags } from '../hooks/useFeatureFlags';
import { CommonDataContext } from './CommonDataContext';
// Note: the provider can NOT be in the same file as the context. That causes a circular
// reference between the context itself and useSymptomPrioritiesById.
export function CommonDataContextProvider({ children, }) {
    const symptomPriorities = useSymptomPriorities();
    const symptomPrioritiesById = useSymptomPrioritiesById();
    const featureFlags = useFeatureFlags();
    const value = useMemo(() => ({
        symptomPriorities: symptomPriorities || [],
        symptomPrioritiesById,
        featureFlags,
    }), [symptomPriorities, symptomPrioritiesById, featureFlags]);
    return (_jsx(CommonDataContext.Provider, Object.assign({ value: value }, { children: children })));
}
